import epsClient from 'enrollment-platform/api/eps.client'

/**
 * Sends an `employer_login` demo event to EPS.
 *
 * Authenticated via the Cognito idToken that `epsClient` attaches as the
 * `Authorization` header. Errors are caught and swallowed — this is a
 * best-effort monitoring call and must never affect the user's session.
 */
export async function postDemoEmployerLogin(
  clientPublicKey: string
): Promise<void> {
  try {
    await epsClient.post(`/api/v1/customers/${clientPublicKey}/demo/events`, {
      type: 'employer_login',
    })
  } catch {
    // Best-effort — do not surface monitoring errors to the user.
  }
}
